const erosionSwipeListener = (() => {
	let touchstartX = 0;
	let touchstartY = 0;
	let touchendX = 0;
	let touchendY = 0;

	function handleGesture(touchstartX, touchstartY, touchendX, touchendY) {
		const delx = touchendX - touchstartX;
		const dely = touchendY - touchstartY;
		if (Math.abs(delx) > Math.abs(dely)) {
			if (delx > 0) {
				document.dispatchEvent(new CustomEvent('erosionSwipe', {
					detail: { direction: 'right' }
				}));
				return

			}
			else {
				document.dispatchEvent(new CustomEvent('erosionSwipe', {
					detail: { direction: 'left' }
				}));
				return
			}
		}
		else if (Math.abs(delx) < Math.abs(dely)) {
			if (dely > 0) return "down"
			else return "up"
		}
		else return "tap"
	}

	const gestureZone = document.getElementById('primary');
	gestureZone.addEventListener('touchstart', function (event) {
		touchstartX = event.changedTouches[0].screenX;
		touchstartY = event.changedTouches[0].screenY;
	}, false);

	gestureZone.addEventListener('touchend', function (event) {
		touchendX = event.changedTouches[0].screenX;
		touchendY = event.changedTouches[0].screenY;
		handleGesture(touchstartX, touchstartY, touchendX, touchendY)
	}, false);
})();